import { Observable } from '../Observable';
import { noop } from '../util/noop';
export const NEVER = new Observable(noop);
export function never() {
    return NEVER;
}
